import React from "react";
import PropTypes from "prop-types";
import { Row, Radio } from "antd";
import { getScheduleVal } from "../../../utils/report";

export const QuaterlyMonthChangeHandler = (value, record) => {
  let setvalue;
  if (record.schedule_trigger_type === 2) {
    let val2 = getScheduleVal(record, 2);
    if (val2 === undefined) {
      val2 = "Monday";
    }
    let week = getScheduleVal(record, 1);
    if (week === undefined) {
      week = "1";
    }
    setvalue = `${value}_${week}_${val2}`;
  } else if (record.schedule_trigger_type === 1) {
    let date = getScheduleVal(record, 4);
    if (date === undefined) {
      date = "1";
    }
    setvalue = `${value}_${date}`;
  }
  return setvalue;
};

export const QuarterlyMonth = (props) => {
  const { value, onChange } = props;
  return (
    <Row justify="center">
      <Radio.Group value={value} buttonStyle="solid" onChange={onChange}>
        <Radio.Button value="1">Month 1</Radio.Button>
        <Radio.Button value="2">Month 2</Radio.Button>
        <Radio.Button value="3">Month 3</Radio.Button>
      </Radio.Group>
    </Row>
  );
};

QuarterlyMonth.propTypes = {
  value: PropTypes.string,
};

export default QuarterlyMonth;
